'use client'
import React, {useEffect, useState} from "react";
import Image from "next/image";
import AppIcon from "@/app/components/atomic/AppIcon";
import ReviewCard from "@/app/components/pageModels/healthLanding/components/ReviewCard";
import {useHealthLandingStore} from "@/app/stores/health/health-landing-store";
import {useShallow} from "zustand/react/shallow";
import {fetchReviewData} from "@/app/endpoints/auctorEndpoints";
import dynamic from "next/dynamic";

const ReviewBlock = ({notation, reviewNumber}: { notation: number, reviewNumber: number }) => {
    return <div className="hidden rm-md:block">
        <span className="text-blue-500 text-rm-22 font-semibold rm-lg:text-rm-26">
            Le meilleur comparateur du marché
        </span>

        <p className="mt-rm-5 mb-0 text-blue-900 text-rm-14">
            <span className="rm-md:hidden rm-lg:inline">À partir des&nbsp;</span>
            <span className="hidden rm-md:inline rm-lg:hidden">Avec nos&nbsp;</span>

            <a
                className="font-semibold underline"
                href="https://reassurez-moi.fr/avis"
                target="_blank"
            >
                {reviewNumber} avis
            </a>
            &nbsp;de nos clients, nous obtenons&nbsp;
            <strong className="font-semibold">la note de {notation}/5</strong>
            &nbsp;sur Avis Vérifiés.
        </p>
    </div>
}

export default function HealthReviewSection() {
    const [notation, setNotation] = useState({notation: 5, reviewNumber: 1197});

    const {currentSale} = useHealthLandingStore(useShallow(
        (state) => ({
            currentSale: state.currentSale,
        }),
    ))

    useEffect(() => {
        // we need to declare an await function into the useEffect for this component to work in client components
        async function fetchNotation() {
            const {notation, reviewNumber} = await fetchReviewData();

            setNotation({notation, reviewNumber});
        }

        // fire and forget async call to update the notation when it's ready
        fetchNotation();
    }, []);

    return (
        <div className="bg-gradient-to-b from-[#EAF4FF] to-blue-100 relative border-t border-blue-200">
            <div className="max-w-screen-xl mx-auto rm-sm:pt-rm-50 p-rm-25 pb-0 rm-xs:px-rm-25 rm-sm:px-rm-50 rm-xl:px-rm-75">
                <div className="flex justify-between items-center rm-md:justify-start rm-md:gap-rm-20">
                    <div className="relative h-[35px] rm-md:h-[40px] min-w-[100px] rm-lg:min-w-[120px]">
                        <Image
                            className="object-contain"
                            src="/assets/health/companies/AV_COLOR.png"
                            alt="Avis vérifiés"
                            fill
                        />
                    </div>

                    <div className="w-[1px] border-r border-blue-300 h-[40px] rm-md:h-[75px]" />

                    <div className="flex flex-col items-end rm-md:hidden">
                        <span className="text-yellow-800 mr-1 text-rm-12 font-semibold">
                            <AppIcon iconClassName="fa-star" className="mr-1 text-rm-12" />
                            {notation.notation} sur 5
                        </span>
                        <a
                            className="text-blue-500 text-rm-12 rm-lg:text-rm-26 underline"
                            href="https://reassurez-moi.fr/avis"
                            target="_blank"
                        >
                            {notation.reviewNumber} avis clients
                        </a>
                    </div>
                    <div className="hidden rm-md:block">
                        <ReviewBlock notation={notation.notation} reviewNumber={notation.reviewNumber}></ReviewBlock>
                    </div>
                </div>

                <div className="mt-rm-50 rm-md:hidden">
                    <ReviewBlock notation={notation.notation} reviewNumber={notation.reviewNumber}></ReviewBlock>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-rm-20 h-full mt-rm-50 max-w-screen-xl mx-auto p-rm-25 pt-0 rm-lg:pt-0 sm:px-rm-50 rm-xl:px-rm-75 pb-rm-75">
                {currentSale.reviews.map((review, index) => (
                    <ReviewCard key={index} review={review} />
                ))}
            </div>
        </div>
    )
}
